import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import Tooltip from "@material-ui/core/Tooltip";
import { instance } from "Actions/AxiosInstance";
import {
  CheckActionPermission,
  setPreview as setPreviewAction,
} from "Actions/commonAction";
import {
  removeSaveProgress,
  setSaveProgress,
} from "Actions/SaveProgressAction";
import infoIcon from "Assets/newicons/notify/info/outline/info-outline-16px.svg";
import emptyImgae from "Assets/Svg/career-page.svg";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import SearchSq from "Component/Material-ui/SearchSq";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import Configs from "Constants/Configs";
import headersList from "Constants/headersList";
import get from "lodash/get";
import {
  List,
  TDTypeConsts,
} from "Module/Subscription/business-configration/commons";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Link, Redirect, Route, Switch, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import createstore from "store";
import Create from "./create";
import PreviewComp from "./PreviewComp";

let shouldCallAPI = true;

const timer = 0;
const delay = 200;
const prevent = false;

class CareerPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      listdata: [],
      htmlPreview: false,
      offset: 0,
      limit: 10,
      value: 0,
      data: false,
      postData: null,
      copypolicy: null,
      nofuel: false,
      selectedRow: null,
      ishiringmanager: false,
      right: false,
      ispipeline: false,
      open: false,
      pdfurl: "",
      drcv: false,
      viewbtn: true,
      jobTemplates: [],
      newpolicycreate: false,
      headers: [
        {
          key: "sectiontypename",
          name: "Section name",
          type: TDTypeConsts.EXPENSE_POLICY_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "imagepath",
          name: "Created By",
          type: TDTypeConsts.CREATED_BY,
        },
        {
          key: "isactive",
          name: "Status",
          type: TDTypeConsts.STATE_ACTIVE_INACTIVE,
        },
        {
          key: "moreoptions",
          type: TDTypeConsts.MORE_OPTIONS,
        },
      ],

      sitePreview: [],
    };

    this.getCarrerPage = this.getCarrerPage.bind(this);
    this.renderList = this.renderList.bind(this);
    this.renderCreate = this.renderCreate.bind(this);
    this.onCreate = this.onCreate.bind(this);
    // this.create = this.create.bind(this);
    this.onEdit = this.onEdit.bind(this);
    // this.onDelete = this.onDelete.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
    this.editHiringMangers = this.editHiringMangers.bind(this);
    this.updatePostData = this.updatePostData.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onPublish = this.onPublish.bind(this);
    this.getPreview = this.getPreview.bind(this);
    this.goToPublishedPage = this.goToPublishedPage.bind(this);
    this.getJobTemplate = this.getJobTemplate.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  componentWillMount() {
    if (this.props.history.location.pathname.includes("create")) {
      this.props.history.push(`${this.props.match.path}/list`);
    }
  }

  getJobTemplate = () => {
    instance
      .get("recruit/getrequisitionjoblist ")
      .then((result) => {
        this.setState({ jobTemplates: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  onStateStatusChange = (value, selectedRow) => {
    const data = {
      careerpagesectionid: selectedRow.careerpagesectionid
        ? selectedRow.careerpagesectionid
        : null,
      isactive: value == 1 ? true : false,
    };

    this.props.enqueueSnackbar(
      "Are you sure you want to change status of this section?",
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              this.props.closeSnackbar();
              instance
                .post("recruit/activeinactivecareerpagesection", data)
                .then((res) => {
                  this.setState(
                    {
                      isActive: res.data.result,
                    },
                    () => this.getCarrerPage(),
                  );
                });
            }}
          >
            Yes
          </Button>,

          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      },
    );
  };

  getCareerPageConfigData() {
    const sitePreview = this.state;
    // const data = { unpublishedid: 0 };
    instance.get(`/recruit/careerpage/0`).then((resp) => {
      this.setState({
        sitePreview: resp.data.result,
        htmlPreview: true,
      });
    });
    this.setState({ sitePreview });
  }

  toggleDrawer = (side, open, flag) => () => {
    if (flag === "ispipeline") {
      this.setState({
        ispipeline: true,
        ishiringmanager: false,

        [side]: open,
      });
    } else if (flag === "ishiringmanager") {
      this.setState({
        ishiringmanager: true,
        ispipeline: false,

        [side]: open,
      });
    } else if (!flag) {
      this.setState({
        [side]: open,
        expanded: false,
        ishiringmanager: false,
        ispipeline: false,
      });
    }
  };

  getPreview() {
    this.setState({ htmlPreview: true });
  }

  goToPublishedPage() {
    this.setState({ htmlPreview: true });
  }

  editHiringMangers() {
    this.setState({
      ishiringmanager: !this.state.ishiringmanager,
      right: true,
      ispipeline: false,
    });
  }

  handleScroll1 = () => {
    const windowBottom =
      Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
    if (windowBottom >= Math.floor(window.innerHeight * 0.65)) {
      if (shouldCallAPI) {
        if (this.state.fullcount > this.state.offset) {
          shouldCallAPI = false;
          this.setState(
            {
              offset: this.state.offset + 10,
            },
            () => this.callAllLeavePolicy(),
          );
          setTimeout(() => {
            shouldCallAPI = true;
          }, 5000);
        } else {
          this.setState({
            message: "no data",
          });
        }
      }
    }
  };

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("careerPage");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getCarrerPage(true, false);
        this.getJobTemplate();
        if (!this.state.permissions.editable) {
          const index =
            this.state.headers &&
            this.state.headers.findIndex(
              (x) => x.type == TDTypeConsts.MORE_OPTIONS,
            );
          if (index != -1) {
            this.state.headers && this.state.headers.splice(index, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index =
            this.state.headers &&
            this.state.headers.findIndex(
              (x) => x.type == TDTypeConsts.STATE_ACTIVE_INACTIVE,
            );
          if (index != -1) {
            this.state.headers && this.state.headers.splice(index, 1);
          }
        }
      });

      if (this.props.history.location.pathname.includes("create")) {
        this.props.history.push(`${this.props.match.path}`);
      }
    } else {
      this.setState({ permissiondenied: true });
    }

    const { SubscriptionInfo } = createstore.getState();
    const subDomain = get(SubscriptionInfo, "SubscriptionData.subdomain", "");
    this.setState({ subDomain });
  }

  getCarrerPage() {
    instance
      .post(`recruit/getcareerpageallsection`, {
        // isactive: "",
        isactive: null,
        limit: 10,
        offset: 0,
      })
      .then((resp) => {
        this.setState({
          listdata: resp.data.result,
          backupList: resp.data.result,
          data: true,
        });
      });
    // this.setState({ listdata: resp.data.result, data: true });
  }

  updatePostData(postData) {
    this.setState({ postData });
  }

  onCancel() {
    const { postData } = this.state;
    this.props.history.push(`${this.props.match.path}`);
    this.getCarrerPage();
    this.setState({
      createmenu: false,
      postData: {
        careerpagesectionid: null,
        title: null,
        sectiontypeid: null,
        sectionbodypath: null,
        description: null,
        sectiondetail: [],
      },
    });
  }

  onCreate() {
    this.setState(
      {
        postData: {
          careerpagesectionid: null,
          title: null,
          sectiontypeid: null,
          sectionbodypath: null,
          description: null,
          sectiondetail: [],
        },
      },
      () => {
        this.props.history.push(`${this.props.match.url}/create`);
      },
    );
  }

  // onPublish() {
  //   const { listdata } = this.state;
  //   // const datas = {
  //   //   statusid: 3,
  //   //   currentstageid: 1,
  //   //   emailid: this.state.owners[0].emailid,
  //   // };

  //   instance
  //     .put(`/recruit/publishcareerpage`)
  //     .then((result) => {
  //       // this.setState({
  //       //   ...result.data.result,
  //       // });
  //       this.props.enqueueSnackbar("publish successfully.", {
  //         variant: "success",
  //       });
  //       // // console.log(...result)
  //       // this.GetAllLead();
  //     })
  //     .catch((error) => {
  //       this.props.enqueueSnackbar(
  //         error.response ? error.response.data.error.message : error.message,
  //         { variant: "error" },
  //       );
  //     });
  // }

  onPublish = () => {
    const { listdata } = this.state;
    const data = {
      // payrollcycledurationid: salarycycle.payrollcycledurationid,
      // salarycycleid: salarycycle.salarycycleid,
      // salarycyclesplitid: salarycycle.displayvalue,
      // ispayrolldone: true,
    };
    this.props.enqueueSnackbar(`Are you sure want to publish?`, {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            this.props.closeSnackbar();
            instance
              .put(`/recruit/publishcareerpage`)
              .then((result) => {
                this.setState({
                  ...result.data.result,
                  htmlPreview: false,
                });
                this.props.enqueueSnackbar("publish successfully.", {
                  variant: "success",
                });
              })
              .catch((error) => {
                this.props.enqueueSnackbar(
                  error.response
                    ? error.response.data.error.message
                    : error.message,
                  { variant: "error" },
                );
              });
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  };

  onEdit() {
    const { selectedRow } = this.state;
    instance
      .get(`/recruit/getcareerpagesection/${selectedRow.careerpagesectionid}`)
      .then((resp) => {
        // resp.data.result[0].participant = tempparticipant;
        this.setState(
          { createmenu: false, postData: resp.data.result[0] },
          () => {
            this.props.history.push(`${this.props.match.url}/create`);
          },
        );
      });
  }

  onDelete() {
    const { selectedRow } = this.state;
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            instance
              .post(`recruit/deletecareerpagesection`, {
                careerpagesectionid: selectedRow.careerpagesectionid,
              })
              .then(
                () => {
                  this.props.enqueueSnackbar("Deleted successfully", {
                    variant: "success",
                  });
                  this.props.closeSnackbar();
                  this.setState(
                    {
                      backupList: [],
                      createmenu: false,
                    },
                    () => {
                      this.getCarrerPage();
                    },
                  );
                },
                (error) => {
                  const CommonError = error.response
                    ? error.response.data.error.message
                    : error.message;
                  this.props.enqueueSnackbar(CommonError, { variant: "error" });
                  this.props.closeSnackbar();
                },
              );
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  renderCreate() {
    return (
      <Create
        {...this.props}
        postData={this.state.postData}
        onCreate={true}
        updatePostData={this.updatePostData}
        getCarrerPage={this.getCarrerPage}
        onCancel={this.onCancel}
        listdata={this.state.listdata}
      />
    );
  }

  handleSearch(e) {
    const { backupList, listdata } = this.state;
    const filterList = listdata.filter(
      (item) =>
        item.sectiontypename
          .toLowerCase()
          .search(e.target.value.toLowerCase()) !== -1,
    );
    this.setState({
      searchValue: e.target.value,
      listdata: e.target.value ? filterList : backupList,
      // isdata: filterList.length == 0 ? true : false,
    });
  }

  renderList() {
    const IsSubscriptionDomain =
      this.state.subDomain != "accounts" &&
      this.state.subDomain != "superuser" &&
      this.state.subDomain != "signup";
    if (
      window.location.pathname.includes("careerpage") &&
      Configs.MODE == "DEV" &&
      !IsSubscriptionDomain
    ) {
      window.Beacon("destroy");
    }
    console.log("this.state.listdata.length: ", this.state.listdata.length);
    return (
      <div className="content-outer-wrapper">
        {this.state.listdata.length > 0 ? (
          <div>
            <Grid container className="margin-bottom-16">
              <Grid item md={12} sm={12}>
                <p className="large-text-dark-secondary t-bold margin-bottom-16">
                  Career page configuration
                </p>
              </Grid>

              <Grid
                item
                md={12}
                sm={12}
                className="display-flex"
                style={{ justifyContent: "space-between" }}
              >
                <div style={{ width: "37%", marginRight: 16 }}>
                  <SearchSq
                    placeholder="Search"
                    value={this.state.searchValue}
                    onChange={this.handleSearch}
                  />
                </div>
                {this.state.permissions.editable && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {IsSubscriptionDomain && (
                      <Link
                        className="active-color image-center"
                        target="_blank"
                        rel="noopener noreferrer"
                        // to={`/profile/${this.state.subDomain}`}
                        // to={`${this.state.subDomain}.sumhr.io/career`}
                        to="/career"
                      >
                        <Button
                          variant="contained"
                          className="btn btn-primary-md-blue margin-right-16"
                          color="primary"
                          // onClick={() => this.goToPublishedPage()}
                        >
                          Visit published page
                        </Button>
                      </Link>
                    )}
                    {this.state.permissions.editable && (
                      <Button
                        variant="contained"
                        className="btn btn-primary-md-blue margin-right-16"
                        color="primary"
                        // onClick={() => this.getPreview()}
                        onClick={() => this.getCareerPageConfigData()}
                      >
                        Preview unpublished changes
                      </Button>
                    )}
                    {this.state.permissions.editable && (
                      <Button
                        variant="contained"
                        className={
                          this.state.listdata.length >= 8
                            ? "btn btn-primary-md-grey"
                            : "btn btn-primary-md-blue"
                        }
                        color="primary"
                        onClick={this.onCreate}
                        disabled={
                          this.state.listdata.length >= 8 ? true : false
                        }
                      >
                        Add Section
                      </Button>
                    )}
                    {this.state.listdata.length >= 8 ? (
                      <Tooltip
                        style={{
                          height: 16,
                          float: "right",
                          cursor: "pointer",
                          marginLeft: 8,
                        }}
                        title="You have already added all sections, you can edit each section by clicking on ':' icon and Edit button."
                        placement="right-start"
                      >
                        <img src={infoIcon}></img>
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </Grid>
            </Grid>

            <List
              showOnlyList
              list={this.state.listdata}
              permissions={this.state.permissions}
              headers={this.state.headers}
              onCreate={this.onCreate}
              onEdit={this.onEdit}
              // onPreview={this.onPreview}
              // onDelete={this.onDelete}
              onStateStatusChange={this.onStateStatusChange}
              onMoreOptionClick={(e, row) => this.onMoreOptionClick(e, row)}
            />
            <Popover
              open={this.state.createmenu}
              anchorEl={this.state.create_anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              onClose={() => this.setState({ createmenu: false })}
              className="margin-top-8"
            >
              <Paper style={{ width: 190 }}>
                <div>
                  <MenuListComponent>
                    <ListItem
                      className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                      onClick={this.onEdit}
                    >
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">Edit</span>
                      </ListItemText>
                    </ListItem>

                    {/* <ListItem
                      className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                    // onClick={() => this.editPipeline(this.state.temppopoverdata)}
                    >
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">
                          Edit hiring plan
                        </span>
                      </ListItemText>
                    </ListItem> */}
                    <ListItem
                      className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                      onClick={this.onDelete}
                    >
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">Delete</span>
                      </ListItemText>
                    </ListItem>
                  </MenuListComponent>
                </div>
              </Paper>
            </Popover>
          </div>
        ) : (
          <div className="position-rel">
            <DefaultComp
              heading="Welcome to your career page configuration!"
              subheading="Customize your career page to help prospective employees better understand your company and work culture."
              imageSrc={emptyImgae}
            />
            {this.state.permissions.editable && (
              <div className="text-center margin-top-24">
                <Button
                  className="btn btn-primary-md-blue"
                  variant="contained"
                  onClick={this.onCreate}
                >
                  Let’s start!
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  render() {
    const { match } = this.props;

    return (
      <div>
        <IntlProvider locale="en">
          <div>
            <Helmet>
              <title>{headersList.Config.ATS.CarrerPage.header}</title>
            </Helmet>
            {this.state.permissiondenied ? (
              <div className="position-rel">
                <PermissionDeniedComp />
              </div>
            ) : (
              <div>
                {this.state.data && (
                  <div>
                    <Switch>
                      <Route
                        exact
                        path={`${match.path}`}
                        render={this.renderList}
                      />
                      <Route
                        exact
                        path={`${match.path}/create`}
                        render={this.renderCreate}
                      />
                      <Redirect from={`${match.path}`} to={`${match.path}`} />
                    </Switch>
                    {/* {this.state.htmlPreview && ( */}
                    <Dialog
                      fullWidth={true}
                      // fullScreen
                      maxWidth="lg"
                      open={this.state.htmlPreview}
                      onClose={() => this.setState({ htmlPreview: false })}
                      aria-labelledby="max-width-dialog-title"
                    >
                      <DialogContent>
                        <div
                          className="margin-bottom-16 text-align-right width100"
                          style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            width: "100%",
                            background: "#fff",
                            zIndex: 10,
                            padding: "8px 24px",
                          }}
                        >
                          <Button
                            variant="contained"
                            className="btn btn-trans margin-right-16"
                            color="primary"
                            onClick={() =>
                              this.setState({ htmlPreview: false })
                            }
                          >
                            Cancel
                          </Button>
                          {this.state.permissions.editable && (
                            <Button
                              variant="contained"
                              className="btn btn-primary-md-blue"
                              color="primary"
                              onClick={this.onPublish}
                            >
                              Publish
                            </Button>
                          )}
                        </div>
                        <PreviewComp
                          sitePreview={this.state.sitePreview}
                          jobTemplates={this.state.jobTemplates}
                        />
                      </DialogContent>
                    </Dialog>
                    {/* )} */}
                  </div>
                )}
              </div>
            )}{" "}
          </div>
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
      setSaveProgress,
      removeSaveProgress,
    },
    dispatch,
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(CareerPage)),
);

// const POST_DATA = {
//   careerpagesectionid: null,
//   title: " ",
//   sectiontypeid: null,
//   sectionbodypath: null,
//   description: " ",
//   sectiondetail: [],
// };
